import React from "react";
import { Container, PageHeader } from "@/components/common";
import { Mail, MapPin, Facebook } from "lucide-react";

export default function Contact() {
  return (
    <div>
      <PageHeader eyebrow="Get in touch" title="Say hello"
        subtitle="Got a question about classes, events or joining the club? We'd love to hear from you." />
      <Container className="py-10">
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-3">
          <a href="mailto:hello@lawleylinedancers.uk" data-testid="contact-email" className="card-hover rounded-2xl border border-border bg-card p-6">
            <Mail size={24} className="text-[#B04B26]" />
            <h3 className="mt-3 font-display text-lg font-bold text-[#2D1E18]">Email us</h3>
            <p className="mt-1 text-sm text-[#5C4A42]">hello@lawleylinedancers.uk</p>
          </a>
          <div className="rounded-2xl border border-border bg-card p-6">
            <MapPin size={24} className="text-[#B04B26]" />
            <h3 className="mt-3 font-display text-lg font-bold text-[#2D1E18]">Where we dance</h3>
            <p className="mt-1 text-sm text-[#5C4A42]">Classes across Telford &amp; Shropshire — Horsehay, Newport, Wellington &amp; Lightmoor.</p>
          </div>
          <div className="rounded-2xl border border-border bg-card p-6">
            <Facebook size={24} className="text-[#B04B26]" />
            <h3 className="mt-3 font-display text-lg font-bold text-[#2D1E18]">Follow along</h3>
            <p className="mt-1 text-sm text-[#5C4A42]">Find Lawley Village Line Dance Club on Facebook for the latest news.</p>
          </div>
        </div>
      </Container>
    </div>
  );
}
